import { createVNode as _createVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import NumberStepper from '@/components/neue/wizard/NumberStepper.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { sectionCopy } from '@/config/agentWizardSteps'
import AgentChooseSection from '@/view/ai/agentWizard/steps/AgentChooseSection.vue'
import AgentMessageField from '@/view/ai/agentWizard/steps/AgentMessageField.vue'


export default {
  __name: 'AgentStepReviews',
  setup(__props) {

const wizard = injectWizard()
const section = wizard.data.reviews

const copy = key => sectionCopy(key, wizard.data, wizard.ctx)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AgentChooseSection, { "step-key": "reviews" }),
    (_unref(section).enabled)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(copy('reviews.when'))), {
            default: _withCtx(() => [
              _createVNode(NumberStepper, {
                modelValue: _unref(section).order_threshold,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_unref(section).order_threshold) = $event)),
                name: "Check in after their order number",
                min: 1
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 16),
          _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(copy('reviews.link'))), {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_unref(section).google_review_link) = $event)),
                type: "url",
                "aria-label": "Google review link",
                placeholder: "https://g.page/r/...",
                class: "block w-full rounded-md border border-gray-300 px-2.5 py-2 text-sm leading-5 text-gray-900 shadow-sm"
              }, null, 512), [
                [_vModelText, _unref(section).google_review_link]
              ])
            ]),
            _: 1
          }, 16),
          _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(copy('reviews.message'))), {
            default: _withCtx(() => [
              _createVNode(AgentMessageField, {
                modelValue: _unref(section).checkin_message,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_unref(section).checkin_message) = $event)),
                label: "Check-in message"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 16)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

}